<div class="gannt-view pl-2 pr-2 box-shadowed d-block f-1 o-auto">
    <div class="d-flex">
        <div class="gannt-view-component f-2" id="container" #divRef></div>
    </div>
</div>
